import { joinPaths } from './URLTools';
import { NotFoundError } from './Errors';
export var Status;

(function (Status) {
  Status["Ready"] = "ready";
  Status["Busy"] = "busy";
  Status["Error"] = "error";
})(Status || (Status = {}));

export function reduceStatuses(x, y) {
  if (x === Status.Error || y === Status.Error) {
    return Status.Error;
  } else if (x === Status.Busy || y === Status.Busy) {
    return Status.Busy;
  }

  return Status.Ready;
}

var Resolver =
/** @class */
function () {
  function Resolver() {
    this.listenerIds = new Map();
    this.nextId = 1;
    this.results = new WeakMap();
    this.isDisposed = false;
  }

  Resolver.prototype.listen = function (listener, resolutionIds) {
    this.listenerIds.set(listener, resolutionIds);
  };

  Resolver.prototype.unlisten = function (listener) {
    this.listenerIds.delete(listener);
  };

  Resolver.prototype.resolve = function (env, resolvable) {
    var matcherResults = this.results.get(env);

    if (!matcherResults) {
      matcherResults = new Map();
      this.results.set(env, matcherResults);
    }

    var currentResult = matcherResults.get(resolvable);

    if (currentResult) {
      return currentResult;
    }

    var id = this.nextId++;
    var maybeValue = resolvable(env);

    if (!isPromiseLike(maybeValue)) {
      var result_1 = {
        id: id,
        status: Status.Ready,
        value: maybeValue
      };
      matcherResults.set(resolvable, result_1);
      return result_1;
    }

    var result = {
      id: id,
      status: Status.Busy
    };
    matcherResults.set(resolvable, result);
    this.listenForChanges(maybeValue, matcherResults, resolvable, id, joinPaths(env.pathname, env.unmatchedPathnamePart));
    return result;
  };

  Resolver.prototype.listenForChanges = function (maybeValue, matcherResults, resolvable, id, fullPathname) {
    var _this = this;

    maybeValue.then(function (value) {
      var currentResult = matcherResults.get(resolvable);

      if (currentResult && currentResult.id === id) {
        matcherResults.set(resolvable, {
          id: currentResult.id,
          status: Status.Ready,
          value: extractDefault(value)
        });
        return true;
      }
    }, function (error) {
      var currentResult = matcherResults.get(resolvable);

      if (error instanceof NotFoundError && !error.pathname) {
        error.pathname = fullPathname;
      }

      if (currentResult && currentResult.id === id) {
        matcherResults.set(resolvable, {
          id: currentResult.id,
          status: Status.Error,
          error: error || new Error()
        });
        return true;
      }
    }).then(function (didUpdate) {
      // Call any listeners that want to be notified of changes
      // to this resolvable
      if (didUpdate) {
        var listenerIds = Array.from(_this.listenerIds.entries());

        for (var i = 0; i < listenerIds.length; i++) {
          var _a = listenerIds[i],
              listener = _a[0],
              ids = _a[1];

          if (ids.indexOf(id) !== -1) {
            listener();
          }
        }
      }
    });
  };

  return Resolver;
}();

export { Resolver }; // Not all promise libraries use the ES6 `Promise` constructor,
// so there isn't a better way to check if it's a promise :-(

function isPromiseLike(x) {
  return !!x && !!x['then'];
}

function extractDefault(value) {
  if (hasDefault(value)) {
    return value.default;
  } else {
    return value;
  }
}

function hasDefault(value) {
  return value && typeof value === 'object' && 'default' in value;
}